import { Injectable } from '@angular/core';
import { CanActivate, Router, NavigationEnd } from '@angular/router';
import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private appService: AppService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url.includes('data-connection') || event.url.includes('collaboration') || event.url.includes('user')) {
        this.appService.showEngagements = false;
      } else {
        this.appService.showEngagements = true;
      }
    });
  }
  /**
   * Decides if a route can be activated depending on the user's attributes.
   * If all guards return `true`, navigation will continue. If any guard returns `false`,
   * navigation will be cancelled.
   *
   * @return An observable indicating if the route is able to be activated.
   */
  canActivate(): Promise<boolean> | boolean {
    const loginState = this.authService.loginState;
    if (!loginState) {
      // user is not logged in, redirect to login
      this.authService.federatedOktaSignIn();
    }
    return this.authService.fetchUserDetails();
  }
}
